export default "__VITE_ASSET__376c801c__"